import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY_M} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

interface NavigateToPaymentParams extends NavigationTypeSelectableParam {
    seqId: string
    type: 'SUBSCRIPTION' | 'PAYMENT'
}

const navigateToPayment = createAsyncThunk<NavigationResult, NavigateToPaymentParams, ThunkApi>(
    'navigateTo/payment',
    async ({seqId, type}) => {
        const url = `${PAY_M}/payments/${type === 'SUBSCRIPTION' ? 'recurrent/' : ''}${seqId}`

        changeBrowserLocation({
            url,
            type: 'PUSH',
        })

        return Promise.resolve()
    },
)

export default navigateToPayment
